module.exports = __webpack_public_path__ + "img/arkman.76f7e581.png";